export const SHORTCUT: string = 'SHORTCUT'

export const COMMAND_LINE: string = 'COMMAND_LINE'

export const COMMAND_LINE_DEFAULT: string = 'COMMAND_LINE_DEFAULT'
export const COMMAND_LINE_READ: string = 'COMMAND_LINE_READ'
export const COMMAND_LINE_OPEN_SOURCE: string = 'COMMAND_LINE_OPEN_SOURCE'

export const GO_TO_HOME: string = 'GO_TO_HOME'
export const GO_TO_CAREERS: string = 'GO_TO_CAREERS'
export const GO_TO_LABS: string = 'GO_TO_LABS'
export const GO_TO_ABOUT: string = 'GO_TO_ABOUT'
export const GO_TO_ARTICLES: string = 'GO_TO_ARTICLES'
export const GO_TO_ARTICLE: string = 'GO_TO_ARTICLE'

export const GO_TO_saigoi_GITHUB: string = 'GO_TO_saigoi_GITHUB'

export const GO_TO_TWITTER: string = 'GO_TO_TWITTER'
export const GO_TO_LINKEDIN: string = 'GO_TO_LINKEDIN'
export const GO_TO_INSTAGRAM: string = 'GO_TO_INSTAGRAM'

export const CONTACT: string = 'CONTACT'

export const ESCAPE: string = 'ESCAPE'
